const translations = {
  "en": {
    "Confirm": "Confirm",
    "Connect another brokerage": "Connect another brokerage",
    "My accounts": "My accounts",
    "Portfolio shows your investment accounts only": "Portfolio shows your investment accounts only",
    "Upload holdings-screenshot or files": "Upload holdings-screenshot or files",
    "Your portfolio accounts": "Your portfolio accounts"
  },
  "zh-tw": {
    "Confirm": "確認",
    "Connect another brokerage": "連結另一家券商",
    "My accounts": "我的帳戶",
    "Portfolio shows your investment accounts only": "投資組合僅顯示你的投資帳戶。",
    "Upload holdings-screenshot or files": "上傳持倉截圖或檔案",
    "Your portfolio accounts": "你的投資組合帳戶"
  }
};

export default translations;
